import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchRedirects, findRedirect, trackRedirect, type RedirectRule } from "@/lib/redirects";

// Aplica os Redirecionamentos (301/302) cadastrados no painel.
// Como o site é uma SPA, o redirecionamento acontece na navegação do navegador.
export default function RedirectHandler() {
  const location = useLocation();
  const navigate = useNavigate();
  const [rules, setRules] = useState<RedirectRule[]>([]);
  const tracked = useRef<Set<string>>(new Set());

  useEffect(() => {
    let cancelled = false;
    const load = () => {
      fetchRedirects().then((r) => {
        if (!cancelled) setRules(r);
      });
    };
    load();
    window.addEventListener("redirects-updated", load);
    return () => {
      cancelled = true;
      window.removeEventListener("redirects-updated", load);
    };
  }, []);

  useEffect(() => {
    if (!rules.length) return;
    const rule = findRedirect(rules, location.pathname);
    if (!rule) return;

    const to = rule.to_path;

    // Conta o acesso apenas uma vez por caminho nesta sessão (evita duplo registro em re-render).
    if (!tracked.current.has(rule.from_path)) {
      tracked.current.add(rule.from_path);
      void trackRedirect(rule.from_path);
    }

    if (/^https?:\/\//i.test(to)) {
      window.location.replace(to);
      return;
    }
    const current = location.pathname.replace(/\/+$/, "") || "/";
    if (to.replace(/\/+$/, "") === current) return;
    navigate(to, { replace: true });
  }, [rules, location.pathname, navigate]);

  return null;
}